import React, { useState, useEffect } from "react";
import styles from "./entityCard.module.scss";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import FileService from "services/file.service";
import { Image } from "react-bootstrap";
import cx from "classnames";
import defaultAsset from "images/default_asset.jpg";
import { trackAdoptionMetricsForAssetDetailViewedEvent } from "actions/adoption";
import Truncate from "react-truncate";

const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

export const EntityCard = ({ entity }) => {

  const dispatch = useDispatch();

  const formatPercentage = (percent) => {
    percent = percent || 0;
    percent = percent * 100;
    percent = percent.toFixed(0);

    if (percent > 100) {
      percent = 100;
    }

    return percent + "%";
  };

  const padNumber = (number = 0, pad) => {
    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  };

  if (_.get(entity, "metadata")) {
    const name = _.get(entity, "name") || "Untitled";
    const metadata = _.get(entity, "metadata");
    const fileType = FileService.fileType(metadata);
    const assetSize = metadata
      ? FileService.formatSize(metadata.content_length)
      : "";
    const url = `${webAppUrl}/assets/${entity.id}?source=chrome_extension`;

    return (
      <a href={url} target="_blank" className={styles.assetCard}
        onClick={() => {
          dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Meeting", FileService.fileType(_.get(entity, "metadata"))));
        }}
      >
        <Image
          className={styles.icon}
          src={_.get(entity, "icon.full", defaultAsset)}
          width={36}
          height={36}
        />
        <div className={styles.assetInfo}>
          <div className={styles.assetTitle}>
          <Truncate lines={1}>{name}</Truncate></div>
          {(fileType !== "INTERACTIVE" && fileType !== "LINK" && assetSize) && (
            <div className={styles.assetDescription}>{assetSize}</div>
          )}
          <i className={cx("paperflite-redirect", styles.redirectIcon)}/>
        </div>
      </a>
    );
  }

  const name = _.get(entity, "share.subject");
  let timeSpent = _.get(entity, "share.totalTimeSpent");
  let minutes = padNumber(Math.floor(timeSpent / 60), 2);
  let seconds = padNumber(Math.floor(timeSpent % 60), 2);
  const url = `${webAppUrl}/conversations/${entity.share.id}?source=chrome_extension`;

  return (
    <a href={url} target="_blank"  className={styles.shareCard}>
      <Image
        className={styles.icon}
        src={_.get(entity, "share.icon.full", defaultAsset)}
        width={36}
        height={36}
      />
      <div className={styles.shareInfo}>
        <div className={styles.shareName}>
          <Truncate lines={1}>{name}</Truncate></div>
        <div className={styles.shareMetrics}>
          <span className={styles.metric}>
            <span
              className={cx("paperflite-mail-open", styles.metricsIcon)}
            ></span>
            {entity.totalRecipients > 0
              ? formatPercentage(
                  entity.share.uniqueEmailOpens / entity.totalRecipients
                )
              : "0%"}
          </span>
          <span className={styles.metric}>
            <span
              className={cx("paperflite-click-rate", styles.metricsIcon)}
            ></span>
            {entity.totalRecipients > 0
              ? formatPercentage(
                  entity.share.uniqueLinkClicks / entity.totalRecipients
                )
              : "0%"}
          </span>
          <span className={styles.metric}>
            <span className={cx("paperflite-clock", styles.metricsIcon)}></span>
            {`${minutes}:${seconds}`}
          </span>
          <i className={cx("paperflite-redirect", styles.redirectIcon)}/>
        </div>
      </div>
    </a>
  );
};

export const PlaceholderCard = () => {
  return (
    <div className={styles.placeholderCard}>
      <div className={styles.placeholderIcon} />
      <div className={styles.placeholderInfo}>
        <div className={styles.placeholderTitle} />
        <div className={styles.placeholderDescription} />
      </div>
    </div>
  );
};

export default EntityCard;
